export default __webpack_public_path__ + "static/media/foodtech500-forward-fooding.f9f5f9b1.png";